import useApi from '../utils/axios-pettitions';
import { useAppDispatch, useAppSelector } from '../contexts/hooks';
import { contextPatient, CustomFilters, DynamicFields, TypeTableFilter } from '../types/types.system';
import { newToast } from '../components';
import { Paciente, PacienteInfo } from '../types/types.patient';
import { setPatient as setPatientO, clearPatient as clearPatientO, setModalPatient, setModePatient, setLoadingPatient, updateFieldOrder, setCurrentPatientToTransfer, setFindedDocument } from '../contexts/slices/orders';
import { setPatient as setPatientQ, clearPatient as clearPatientQ } from '../contexts/slices/quotations';
import { ConvertDataPatient, ConvertDataPatientOrders } from '../utils/functions';
import { setPatient as setPatientA, clearPatient as clearPatientA } from '../contexts/slices/appointments';
import { setPatient as setPatientP, clearPatient as clearPatientP } from '../contexts/slices/preorders';

export const useApiPatient = () => {
  const { runApi } = useApi();
  const dispatch = useAppDispatch();
  const Prm_PacC = useAppSelector((x) => x.userInfo.Permissions?.Prm_PacC);
  const currentPatientO = useAppSelector((x) => x.globalOrders.CurrentOrder.PatientData);
  const currentPatientQ = useAppSelector((x) => x.globalQuotation.PatientData);
  const currentPatientA = useAppSelector((x) => x.globalAppointments.PatientData);
  const currentPatientP = useAppSelector((x) => x.globalPreOrder.PatientData);
  const CreatePatientAndUpdate = useAppSelector((x) => x.globalOrders.CurrentOrder.CreatePatientAndUpdate);

  //Buscar usuario
  const findUser = async (filtros: CustomFilters[], loading: (val: boolean) => void, updateRedux: boolean, context: contextPatient) => {
    loading(true);

    return await runApi('Patients', 'POST', null, filtros)
      .then((res) => {
        if (res.internalCode >= 200) {
          return;
        }
        if (res.internalCode === 101) {
          if (!res.data) {
            return;
          }

          if (updateRedux) {
            switch (context) {
              case 'orders':
                dispatch(setPatientO(ConvertDataPatient(res.data)));
                const Patient: PacienteInfo = res.data[0] as PacienteInfo;
                dispatch(updateFieldOrder({ field: 'Ord_Pc_Id', value: Patient.Paciente.Pc_Id, castMode: null }));
                break;
              case 'quotations':
                dispatch(setPatientQ(ConvertDataPatient(res.data)));
                break;
              case 'appointment':
                dispatch(setPatientA(ConvertDataPatient(res.data)));
                break;
              case 'preorders':
                dispatch(setPatientP(ConvertDataPatient(res.data)));
                break;
            }
          }
          return res.data[0];
        }
        newToast('INFO', res.message, 4);
        if (!Prm_PacC) {
          return;
        }
        //Validar si tiene permisos de crear usuarios, si si lo tiene abrir la modal.
        //De lo contrario clarear
        if (updateRedux) {
          switch (context) {
            case 'orders':
              dispatch(clearPatientO(filtros[0].Value));
              break;
            case 'quotations':
              dispatch(clearPatientQ());
              break;
            case 'appointment':
              dispatch(clearPatientA());
              break;
            case 'preorders':
              dispatch(clearPatientP());
              break;
          }
        }
        dispatch(setFindedDocument(filtros[0].Value));
        dispatch(setModePatient('new'));
        dispatch(setModalPatient({ visible: true, context: context }));
      })
      .finally(() => {
        loading(false);
      });
  };

  //Crear usuario
  const createUser = async (data: any, context: contextPatient) => {
    const paciente: { [key: string]: any } = {};
    const dyn: DynamicFields[] = [];
    Object.keys(data).forEach((element) => {
      if (element === 'AditionalFields') {
        Object.keys(data.AditionalFields).forEach((elDyn) => {
          dyn.push({ Equivalencia: elDyn, Valor: data.AditionalFields[elDyn] });
        });
        return;
      }
      paciente[element] = data[element];
    });

    const resultado = { Paciente: paciente, Dyn: dyn };

    dispatch(setLoadingPatient());
    runApi('Patients/create', 'POST', null, resultado)
      .then((res) => {
        if (res.internalCode >= 200) {
          return;
        }
        if (CreatePatientAndUpdate) {
          switch (context) {
            case 'orders':
              dispatch(setPatientO(ConvertDataPatientOrders(res.data)));
              //Asignamos el id a orden actual.
              const Patient: PacienteInfo = res.data as PacienteInfo;
              dispatch(updateFieldOrder({ field: 'Ord_Pc_Id', value: Patient.Paciente.Pc_Id, castMode: null }));
              break;
            case 'quotations':
              dispatch(setPatientQ(ConvertDataPatientOrders(res.data)));
              break;
            case 'appointment':
              dispatch(setPatientA(ConvertDataPatientOrders(res.data)));
              break;
            case 'preorders':
              dispatch(setPatientP(ConvertDataPatientOrders(res.data)));
              break;
          }
        } else {
          if (res.data) {
            dispatch(setCurrentPatientToTransfer(res.data.Paciente as Paciente));
            newToast('INFO', 'Paciente creado correctamente', 5);
          }
        }
      })
      .finally(() => {
        dispatch(setLoadingPatient());
        dispatch(setModalPatient({ visible: false, context: context }));
        dispatch(setModePatient('view'));
      });
    return;
  };

  const editDocument = async (document: string, patientId: number) => {
    return await runApi('Patients/PutDocument', 'POST', { idPac: patientId, newDocument: document })
      .then((res) => {
        if (res.internalCode === 107) {
          newToast('SUCCESS', res.message, 5);
          return res.data;
        }
        return null;
      })
      .catch(() => {
        return null;
      });
  };

  const editUser = async (data: any, context: contextPatient) => {
    let currentPatient;

    switch (context) {
      case 'orders':
        currentPatient = currentPatientO;
        break;
      case 'quotations':
        currentPatient = currentPatientQ;
        break;
      case 'appointment':
        currentPatient = currentPatientA;
        break;
      case 'preorders':
        currentPatient = currentPatientP;
        break;
      default:
        break;
    }

    if (!currentPatient) {
      newToast('WARNING', 'No se encontró información para el paciente actual', 5);
      return;
    }

    const updatedFields: Array<{ Equivalencia: string; Valor: any }> = [];
    Object.keys(data).forEach((element) => {
      if (element === 'AditionalFields') {
        Object.keys(data.AditionalFields).forEach((elDyn) => {
          if (currentPatient.AditionalFields[elDyn] !== data.AditionalFields[elDyn]) {
            updatedFields.push({ Equivalencia: elDyn, Valor: data.AditionalFields[elDyn] });
          }
        });
      } else if (currentPatient[element] !== data[element]) {
        updatedFields.push({ Equivalencia: element, Valor: data[element] });
      }
    });

    if (updatedFields.length === 0) {
      newToast('INFO', 'Los datos actuales del paciente no han cambiado', 5);
      return;
    }

    dispatch(setLoadingPatient());    
    runApi('Patients/Put', 'POST', { IdPac: currentPatient.Pc_Id }, updatedFields)
      .then((res) => {
        if (res.internalCode === 208) {
          newToast('ERROR', res.message, 5);
          return;
        }
        if (res.internalCode === 107) {
          newToast('SUCCESS', res.message, 5);
          const updatedPatient = ConvertDataPatient(res.data);
          switch (context) {
            case 'orders':
              dispatch(setPatientO(updatedPatient));
              break;
            case 'quotations':
              dispatch(setPatientQ(updatedPatient));
              break;
            case 'preorders':
              dispatch(setPatientP(updatedPatient));
              break;
            default:
              break;
          }
        }
      })
      .finally(() => {
        dispatch(setLoadingPatient());
        dispatch(setModalPatient({ visible: false, context }));
        dispatch(setModePatient('view'));
      });
  };

  //Buscar paciente por ID (sin afectar Redux)
  const searchPatient = async (patientId: number | string) => {
    const filtros: CustomFilters[] = [
      {
        Field: 'Pc_Id',
        TypeFilter: TypeTableFilter.Equal,
        Value: patientId.toString(),
      },
    ];

    return await runApi('Patients', 'POST', null, filtros)
      .then((res) => {
        if (res.internalCode >= 200) {
          return null;
        }
        if (res.internalCode === 101) {
          if (!res.data || res.data.length === 0) {
            return null;
          }
          // Convertir los datos usando la función existente
          return ConvertDataPatient(res.data);
        }
        newToast('INFO', res.message, 4);
        return null;
      })
      .catch((error) => {
        console.error('Error searching patient:', error);
        newToast('ERROR', 'Error al buscar el paciente', 4);
        return null;
      });
  };

  return { findUser, createUser, editUser, searchPatient, editDocument };
};
